<template>
  <div>
    <table id="exchangeList-fileTable" class="ui table">
      <thead>
        <tr class="single line">
          <th width="30px">No.</th>
          <th width="160px">登録時間</th>
          <th>件名</th>
          <th>ファイル名</th>
          <th>ファイルサイズ</th>
          <th>宛先</th>
          <th width="150px">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index" v-bind:data-exchange="item.exchange_id">
          <td class="exchangeList-fileTable__no">{{index + 1}}</td>
          <td
            class="single line exchangeList-fileTable__registerDate"
          >{{item.uploaded_date | datetime}}</td>
          <td class="newline-wrap exchangeList-fileTable__title">{{item.title || '-'}}</td>
          <td class="newline-wrap exchangeList-fileTable__fileName">{{convertFileNames(item.files)}}</td>
          <td class="exchangeList-fileTable__fileSize">{{sumFileSize(item.files) | bytes}}</td>
          <td class="newline exchangeList-fileTable__address">{{convertAddresses(item.addresses)}}</td>
          <td class="single line exchangeList-fileTable__operation">
            <router-link
              tag="button"
              class="ui button blue tiny exchangeList-fileTable__detail"
              :to="{ name: 'exchangeDetail', params: { exchange_id: item.exchange_id }}"
            >詳細</router-link>
            <button
              class="ui button orange tiny exchangeList-fileTable__delete"
              @click="removeFile(item.exchange_id)"
            >削除</button>
          </td>
        </tr>
      </tbody>
    </table>
    <button
      v-if="hasMoreExchange && !isProgressLoading"
      id="exchangeList-getMore"
      v-bind:class="{fluid:true, ui: true, button: true, blue: true, loading: isLoading}"
      @click="getMoreExchange()"
    >
      <i class="angle down icon"></i>さらに表示
    </button>
    <div v-if="!items.length && !isProgressLoading">ファイル交換の履歴がありません。</div>
  </div>
</template>

<script>
import { getExchanges, deleteExchange } from '@/api'
import { compareDate } from '@/common'
import { mapState } from 'vuex'

const CHUNK_SIZE = 20

export default {
  title: 'ファイル交換履歴',
  data: function () {
    return {
      items: [],
      isLoading: false,
      lastEvaluatedKey: {},
      hasMoreExchange: true
    }
  },
  created: function () {
    this.$store.commit('progress/setLoading', true)
    this.initExchanges()
  },
  computed: mapState({
    isProgressLoading: state => state.progress.loading
  }),
  methods: {
    initExchanges: function () {
      getExchanges({})
        .then(response => {
          if (response.length < CHUNK_SIZE) {
            this.hasMoreExchange = false
          }
          if (response.length > 0) {
            const lastEvaluated = response[response.length - 1]
            this.lastEvaluatedKey = {
              exchange_id: lastEvaluated.exchange_id,
              uploaded_date: lastEvaluated.uploaded_date
            }
          }
          response.sort(compareDate)
          this.items = response
          this.$store.commit('progress/setLoading', false)
        })
        .catch(err => {
          console.log(err)
          this.$store.commit('progress/setLoading', false)
          this.$store.commit('infoModal/openModal', {
            type: 'ERROR',
            title: 'ファイル一覧取得',
            message: '通信エラーが発生しました。\nしばらくしてからもう一度お試しください。'
          })
        })
    },

    getMoreExchange: function () {
      this.isLoading = true

      getExchanges(this.lastEvaluatedKey)
        .then(response => {
          if (response.length < CHUNK_SIZE) {
            this.hasMoreExchange = false
          }
          if (response.length > 0) {
            const lastEvaluated = response[response.length - 1]
            this.lastEvaluatedKey = {
              exchange_id: lastEvaluated.exchange_id,
              uploaded_date: lastEvaluated.uploaded_date
            }
          }
          response.sort(compareDate)
          this.items.push.apply(this.items, response)
          this.isLoading = false
        })
        .catch(err => {
          console.log(err)
          this.isLoading = false
          this.$store.commit('infoModal/openModal', {
            type: 'ERROR',
            title: 'ファイル一覧取得',
            message: '通信エラーが発生しました。\nしばらくしてからもう一度お試しください。'
          })
        })
    },

    /** 交換IDにて削除する */
    removeFile: function (exchangeId) {
      const self = this
      this.$store.commit('confirmModal/openModal', {
        title: 'ファイル交換履歴削除',
        message: 'ファイル交換履歴を削除します。\nよろしいですか？',
        executeLabel: '削除',
        callback: function (answer) {
          if (answer) {
            self.$store.commit('progress/setLoading', true)
            deleteExchange(exchangeId)
              .then(() => {
                self.initExchanges()
              })
              .catch(err => {
                console.log(err)
                self.$store.commit('progress/setLoading', false)
                self.$store.commit('infoModal/openModal', {
                  type: 'ERROR',
                  title: 'ファイル削除',
                  message: '通信エラーが発生しました。\nしばらくしてからもう一度お試しください。'
                })
              })
          }
        }
      })
    },

    sumFileSize: function (files) {
      let size = 0
      files.forEach(file => { size += file.size })
      return size
    },

    convertFileNames: function (files) {
      const fileNameList = files.map(file => file.name)
      return fileNameList.join('\n')
    },

    convertAddresses: function (addresses) {
      return addresses.join('\n')
    }
  }
}
</script>
